import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/img10.webp")